export default __webpack_public_path__ + "static/media/DAIF_Services_Screen3_in-end.f8647229.jpg";